// Single source of truth for whether a market accepts new boost contributions.
//
// Boosting is allowed only while the market is in the tradeable (`'trading'`)
// state. Pre-trade setup states (`'created'`, `'backing'`) and post-resolution
// states (`'resolved'`, `'graduated'`) all disallow new boosts.
//
// This predicate is consumed by both `<BoostButton>` (the trade-rail CTA) and
// `<MarketBoostersEmpty>` (the leaderboard empty-state CTA) to keep the gating
// rule consistent across surfaces. See spec 053 FR-006a / EC-7.
import { isMarketTradeable } from '@morfi/contract-sdk';

export function canBoostMarket(market: { status: string }): boolean {
  return isMarketTradeable(market.status);
}
